import React from 'react';
import pagenotfound from "../../assets/images/pagenotfound.svg";
import { Button,Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Box } from 'lucide-react';

export const PageNotFound = () => {
  return (
    <div style={{textAlign:'center', height:'100vh'}}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection:'column',
          height:'100%'
        }}
      >
        <img
          src={pagenotfound}
          alt="Page Not Found"
          width={150}
        />
        <Typography
        textAlign={"center"}
        variant="h4"
        sx={{fontWeight:"bold", mt: 2}}
      >
        Oops! We Can't Find The Page.
      </Typography>

      <Link to="/">
      <Button
        textAlign={"center"}
        variant="outlined"
        sx={{
          textTransform: "none",
          fontSize: "16px",
          mt: 2
        }}
      >
        Back to Home Page
      </Button>
      </Link>
      </div>
    </div>
  );
};
